import { render, staticRenderFns } from "./CommentItemPreview.vue?vue&type=template&id=380a25d8"
import script from "./CommentItemPreview.vue?vue&type=script&lang=js"
export * from "./CommentItemPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports